import {
  Box,
  Input,
  Button,
  VStack,
  Select as SelectChakra,
  Textarea,
  useToast,
  Flex,
  Checkbox,
  Text,
} from "@chakra-ui/react";
import Select from "react-select";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
const BASE_URL = "https://develop-project-360.onrender.com/createLeadDeal";

export const createLead = (payload) => axios.post(`${BASE_URL}`, payload);

const productOptions = [
  { value: "Software", label: "Software" },
  { value: "Consulting", label: "Consulting" },
  { value: "Maintenance", label: "Maintenance" },
  { value: "Training", label: "Training" },
  { value: "Licensing", label: "Licensing" },
  { value: "Hardware", label: "Hardware" },
  { value: "Support", label: "Support" },
  { value: "Others", label: "Others" },
];

export default function CompCreateDeal({ onClose, addNewLead }) {
  const adminIdGlobal = useSelector((store) => store.authentication.users.id);
  const [users, setUsers] = useState([]);

  const handleEmployeeChange = (selectedOptions) => {
    if (selectedOptions.some((opt) => opt.value === "All")) {
      const allIds = users.map((u) => u._id);
      setFormData((prev) => ({
        ...prev,
        assigned_to: allIds,
      }));
    } else {
      const ids = selectedOptions.map((option) => option.value);
      setFormData((prev) => ({
        ...prev,
        assigned_to: ids,
      }));
    }
  };

  const toast = useToast();
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `https://develop-project-360.onrender.com/getUserById?companyId=${adminIdGlobal}`
        );
        setUsers(res.data);
      } catch (error) {
        console.error("Failed to fetch users", error);
      }
    };

    fetchUsers();
  }, [adminIdGlobal]);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    client_name: "",
    client_email: "",
    client_phone: "",
    company_name: "",
    industry: "",
    deal_value: "",
    deal_stage: "",
    products_or_services: [],
    other_product: "",
    actual_closure_date: "",
    payment_status: "",
    amount_paid: "",
    remaining_payment: "",
    payment_terms: "",
    next_action: "",
    contract_signed: "",
    support_required: "",
    type: "Deal",
    assigned_to: [],
    companyId: adminIdGlobal,
    created_by: adminIdGlobal,
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      const { data } = await createLead(formData);
      addNewLead(data);
      toast({
        title: "Deal created successfully",
        description: `${formData.title} created successfully`,
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
      onClose(); // Close the modal
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error("Error creating lead:", error);
      toast({
        title: "Error",
        description: "Failed to create deal",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  return (
    <Box>
      <VStack spacing="2">
        <Input name="title" placeholder="Title" onChange={handleChange} />
        <Textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
        />

        <Input
          name="client_name"
          placeholder="Client Name"
          onChange={handleChange}
        />

        <Flex gap={4} direction={{ base: "column", md: "row" }} w="100%">
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              name="client_email"
              placeholder="Email"
              onChange={handleChange}
              w="100%"
            />
          </Box>
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              name="client_phone"
              placeholder="Phone"
              onChange={handleChange}
              w="100%"
            />
          </Box>
        </Flex>
        <Flex gap={4} direction={{ base: "column", md: "row" }} w="100%">
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              name="company_name"
              placeholder="Company Name"
              onChange={handleChange}
              w="100%"
            />
          </Box>
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              name="industry"
              placeholder="Industry"
              onChange={handleChange}
              w="100%"
            />
          </Box>
        </Flex>
        <Flex gap={4} direction={{ base: "column", md: "row" }} w="100%">
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              name="deal_value"
              placeholder="Deal Value"
              onChange={handleChange}
              w="100%"
            />
          </Box>

          <Box w={{ base: "100%", md: "50%" }}>
            <SelectChakra name="deal_stage" onChange={handleChange} w="100%">
              <option value="">Deal Stage</option>
              <option value="Discovery">Discovery</option>
              <option value="Demo">Demo</option>
              <option value="Proposal">Proposal</option>
              <option value="Negotiation">Negotiation</option>
              <option value="Contract Sent">Contract Sent</option>
              <option value="Closed">Closed</option>
            </SelectChakra>
          </Box>
        </Flex>

        <Flex gap={4} direction={{ base: "column", md: "row" }} w="100%">
          <Box w={{ base: "100%", md: "50%" }}>
            <SelectChakra
              name="payment_status"
              value={formData.payment_status}
              onChange={(e) => {
                const status = e.target.value;
                const { deal_value, amount_paid } = formData;
                let remaining_payment = "";

                if (
                  ["Partially Paid", "Paid", "Overdue"].includes(status) &&
                  deal_value &&
                  amount_paid
                ) {
                  remaining_payment = Number(deal_value) - Number(amount_paid);
                }

                setFormData((prev) => ({
                  ...prev,
                  payment_status: status,
                  remaining_payment,
                }));
              }}
              w="100%"
            >
              <option value="">Payment Status</option>
              <option value="Pending">Pending</option>
              <option value="Partially Paid">Partially Paid</option>
              <option value="Paid">Paid</option>
              <option value="Overdue">Overdue</option>
            </SelectChakra>

            {["Partially Paid", "Paid", "Overdue"].includes(
              formData.payment_status
            ) && (
              <>
                <Input
                  mt={2}
                  placeholder="Amount Paid"
                  type="number"
                  value={formData.amount_paid}
                  onChange={(e) => {
                    const paid = e.target.value;
                    const remaining = formData.deal_value
                      ? Number(formData.deal_value) - Number(paid)
                      : "";
                    setFormData((prev) => ({
                      ...prev,
                      amount_paid: paid,
                      remaining_payment: remaining,
                    }));
                  }}
                />
                <Text color="gray.500" mt={1}>
                  Remaining Payment: ₹{formData.remaining_payment || 0}
                </Text>
              </>
            )}
          </Box>
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              name="payment_terms"
              placeholder="Payment Terms"
              onChange={handleChange}
              w="100%"
            />
          </Box>
        </Flex>
        <Flex gap={4} direction={{ base: "column", md: "row" }} w="100%">
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              type="date"
              name="actual_closure_date"
              placeholder="Actual Closure Date"
              onChange={handleChange}
              w="100%"
            />
          </Box>
          <Box w={{ base: "100%", md: "50%" }}>
            <Input
              name="next_action"
              placeholder="Next Action"
              onChange={handleChange}
              w="100%"
            />
          </Box>
        </Flex>

        <Flex gap={4} direction={{ base: "column", md: "row" }} w="100%">
          <Box w={{ base: "100%", md: "50%" }}>
            <Select
              placeholder="Assign To"
              isMulti
              isSearchable
              name="assigned_to"
              id="assigned_to"
              onChange={handleEmployeeChange}
              options={[
                { value: "All", label: "All" },
                ...users.map((employee) => ({
                  value: employee._id,
                  label: employee.sudo_name || employee.first_name,
                })),
              ]}
              value={formData.assigned_to.map((id) => {
                const employee = users.find((u) => u._id === id);
                return {
                  value: employee?._id,
                  label: employee?.sudo_name || employee?.first_name,
                };
              })}
            />
          </Box>

          <Box w={{ base: "100%", md: "50%" }}>
            <Select
              placeholder="Select Products or Services"
              isMulti
              name="products_or_services"
              options={productOptions}
              onChange={(selectedOptions) =>
                setFormData((prev) => ({
                  ...prev,
                  products_or_services: selectedOptions.map((opt) => opt.value),
                }))
              }
              value={formData.products_or_services.map((val) => ({
                value: val,
                label: val,
              }))}
            />
            {formData.products_or_services.includes("Others") && (
              <Input
                mt={2}
                placeholder="Please specify other product/service"
                name="other_product"
                value={formData.other_product}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    other_product: e.target.value,
                  }))
                }
              />
            )}
          </Box>
        </Flex>
        <SelectChakra name="source" onChange={handleChange}>
          <option value="">Select Source</option>
          <option value="Website">Website</option>
          <option value="Referral">Referral</option>
          <option value="Cold Call">Cold Call</option>
          <option value="Social Media">Social Media</option>
          <option value="Event">Event</option>
          <option value="Others">Others</option>
        </SelectChakra>
        <Checkbox
          mt="4"
          isChecked={formData.contract_signed}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              contract_signed: e.target.checked,
            }))
          }
        >
          Contract Signed
        </Checkbox>

        <Checkbox
          mt="4"
          isChecked={formData.support_required}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              support_required: e.target.checked,
            }))
          }
        >
          Support Required
        </Checkbox>

        <Button colorScheme="teal" w="full" onClick={handleSubmit}>
          Create Deal
        </Button>
      </VStack>
    </Box>
  );
}
